import GenericDB from '../generic-db'

export default class CleanupJobs extends GenericDB {
  constructor() {
    super('cleanupJobs')
  }

  // Here you can extend CleanupJobs with custom methods
}
